import { toast } from 'react-toastify';
import { RESPONSE_MESSAGE } from '../../../../utils/Constant';
import { IKeVatTu, IVatTuItem, SearchVatTuParams } from '../../../../phan-he-kham-benh/models/VatTuModels';
import { searchVatTu } from '../../../../phan-he-kham-benh/services/VatTuService';

export const getListVatTu = async (
	query: SearchVatTuParams,
	setIsLoading?: (flag: boolean) => void
) => {
	try {
		setIsLoading?.(true);

		const response: IVatTuItem[] = await searchVatTu({
			...query,
			pageIndex: 1,
			pageSize: 100,
			isIventoryNoZero: true,
		});
		const result: IKeVatTu[] = response.map((vatTu: IVatTuItem) => ({
			...vatTu,
			id: vatTu.id.toString(),
			donVi: vatTu.unitofMeasureName,
			maVatTu: vatTu.code,
			tenVatTu: vatTu.name,
			tonKho: Number(vatTu.iventory) - Number(vatTu.peShipment),
			bidId: vatTu.bidId,
			serialNumber: vatTu.serialNumber,
			consignment: vatTu.consignment,
			giaBan: vatTu.salePrice,
			rateHealthInsurance: vatTu.rateHealthInsurance,
			svcFee: vatTu.servicePrice,
			svcFeeHospital: vatTu.hospitalPrice,
			svcFeeIns: vatTu.bhytPrice,
		}));

		return result;
	} catch (error) {
		console.error(error);
		toast.error(RESPONSE_MESSAGE.ERROR);
	} finally {
		setIsLoading?.(false);
	}
};
